import ScriptNode from "./script-node"

export default {
  component: ScriptNode,
  commands: {
    insertScript(editor, { scriptId, height, version }) {
      editor.insertBlock({
        type: "script",
        data: { scriptId, height, version }
      })
    }
  },
  schema: {
    isVoid: true
  }
}
